import React, {Component} from 'react'
import {Link} from "react-router-dom"
import PropTypes from 'prop-types'
import ItemStatus from "../ItemStatus"

class TableRow extends Component {
    render() {
        const {index, item} = this.props

        let is3d = item
        if (item.hasOwnProperty('tool3d_order')) {
            is3d = item.tool3d_order
        }

        let status = ''
        if (is3d.production_status === 'cancelled') {
            status = is3d.production_status
        } else {
            if (is3d.hasOwnProperty('batch_item')) {
                status = is3d.batch_item.status
            }else{
                status = is3d.status
            }
        }

        return (
            <tr>
                <td>{index + 1}</td>
                <td>#{is3d.barcode_number}_{is3d.item_number}</td>
                <td>
                    {
                        is3d.hasOwnProperty('batch_item') &&
                        <Link to={`/batches/${is3d.batch_item.batch._id}`}>
                            {is3d.batch_item.batch.name}
                        </Link>
                    }
                </td>
                <td><ItemStatus status={status}/></td>
                <td>{is3d.size}</td>
                <td>{is3d.type}</td>
            </tr>
        )
    }
}

TableRow.propTypes = {
    index: PropTypes.number,
    item: PropTypes.object
}

export default TableRow